var exports = {
  "kL": "xe533113f--f79f4c--container",
  "Mn": "xe533113f--f79f4c--top",
  "Sl": "xe533113f--f79f4c--image",
  "pq": "xe533113f--f79f4c--info",
  "q9": "xe533113f--f79f4c--price",
  "h_": "xe533113f--f79f4c--description",
};

module.exports = exports;
